import {
  Anchor,
  Badge,
  Box,
  Group,
  Stack,
  Text,
  ThemeIcon,
  Title,
  Tooltip,
} from '@mantine/core'
import classes from './Security.module.css'
import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'
import { IconLock } from '@tabler/icons-react'

export const Security = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Security'))
  })

  return (
    <Box w={550} p="md">
      <Stack gap={2}>
        <Group gap={2} align="center">
          <Title order={5}>Email</Title>
          <Tooltip
            position="right-start"
            label="Only admins can update the email used for authentication on staff accounts."
          >
            <ThemeIcon variant="transparent" color="dark">
              <IconLock size={18} />
            </ThemeIcon>
          </Tooltip>
        </Group>
        <Text c="dimmed" size="md">
          alfredo@mybluecard.org
        </Text>
      </Stack>
      <Stack gap={2} mt="lg">
        <Title order={5}>Password</Title>
        <Text c="dimmed" size="md">
          Last changed March 15, 2024
        </Text>
        <Anchor fw="bold">Edit</Anchor>
      </Stack>
      <Stack mt="xl" gap="xs">
        <Group gap={5} align="center">
          <Title order={4}>2-Step verification</Title>
          <Badge color="green" mt={2}>
            Enabled
          </Badge>
        </Group>
        <Text size="sm">
          In addition to your password, 2-step verification adds a quick second
          step to verify that it's you.
        </Text>
        <Stack mt="md" className={classes.Security__item} pb="md" gap="xs">
          <Text>+1 (919) 555-1212</Text>
          <Text size="sm" c="dimmed">
            Added March 15, 2024
          </Text>
        </Stack>
        <Stack mt="md" className={classes.Security__item} pb="md" gap="xs">
          <Text>Authenticator app</Text>
          <Text size="sm" c="dimmed">
            Added March 15, 2024
          </Text>
        </Stack>
        <Anchor fw="bold">Manage 2-step verification</Anchor>
      </Stack>
      <Stack mt="xl" gap="xs">
        <Title order={4}>Sign out everywhere</Title>
        <Text size="sm">
          If you lost a device or left logged in on a public computer, you can
          sign out everywhere except your current browser.
        </Text>
        <Anchor fw="bold" c="red">
          Sign out everywhere
        </Anchor>
      </Stack>
    </Box>
  )
}
